import { Fragment } from "react";
import { ReactComponent as Moon } from "../../styles/icon/moon.svg";
import Button from "../../elements/Button/Button";
import toast from "./Toasts.module.scss";

const DarkModeToast = ({ message, closeToast }) => (
  <Fragment>
    <Moon />
    <p className={toast.toast__text}>{message}</p>
    <Button name="close" onClick={closeToast} variant="close" />
  </Fragment>
);

export default DarkModeToast;
